/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Step1_BodyInputs */

const es_cap_step1_body = /** @type {(inputs: Cap_Step1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuéntanos tu titulación, tu experiencia, tu zona y tus tarifas. Verificamos tus títulos.`)
};

const gl_cap_step1_body = /** @type {(inputs: Cap_Step1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cóntanos a túa titulación, a túa experiencia, a túa zona e as túas tarifas. Verificamos os teus títulos.`)
};

const en_cap_step1_body = /** @type {(inputs: Cap_Step1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us your licence, experience, area, and rates. We verify your credentials.`)
};

/**
* | output |
* | --- |
* | "Tell us your licence, experience, area, and rates. We verify your credentials." |
*
* @param {Cap_Step1_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_step1_body = /** @type {((inputs?: Cap_Step1_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Step1_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_step1_body(inputs)
	if (locale === "en") return en_cap_step1_body(inputs)
	return es_cap_step1_body(inputs)
});